// Licence Type IDs
export const LICENCE_TYPE_ID_HIDE_DEALER = 100;
export const LICENCE_TYPE_ID_LIVESTOCK_DEALER = 101;
export const LICENCE_TYPE_ID_LIVESTOCK_DEALER_AGENT = 102;
export const LICENCE_TYPE_ID_GAME_FARM = 103;
export const LICENCE_TYPE_ID_SLAUGHTERHOUSE = 104;
export const LICENCE_TYPE_ID_DAIRY_FARM = 105;
export const LICENCE_TYPE_ID_DAIRY_TANK_TRUCK = 107;
export const LICENCE_TYPE_ID_BULK_TANK_MILK_GRADER = 106;
export const LICENCE_TYPE_ID_FUR_FARM = 108;
export const LICENCE_TYPE_ID_ARTIFICIAL_INSEMINATION_CENTRE = 109;
export const LICENCE_TYPE_ID_ARTIFICIAL_INSEMINATION_TECHNICIAN = 110;
export const LICENCE_TYPE_ID_AUCTIONEER = 111;
export const LICENCE_TYPE_ID_PUBLIC_SALE_YARD_OPERATOR = 112;
export const LICENCE_TYPE_ID_APIARY = 113;
export const LICENCE_TYPE_ID_VETERINARY_DRUG = 114;
export const LICENCE_TYPE_ID_DISPENSER = 115;
export const LICENCE_TYPE_ID_MEDICATED_FEED = 116;
export const LICENCE_TYPE_ID_YARDMAN = 117;
export const LICENCE_TYPE_ID_PRODUCE_EGG_PRODUCT = 120;
export const LICENCE_TYPE_ID_PRODUCER_GRADER = 121;
export const LICENCE_TYPE_ID_PURCHASE_INEDIBLE_EGG_PRODUCT = 122;
export const LICENCE_TYPE_ID_PURCHASE_LIVE_POULTRY = 123;
export const LICENCE_TYPE_ID_PURCHASE_UNGRADED_EGGS = 124;
export const LICENCE_TYPE_ID_PURCHASE_REJECT_EGGS = 125;
export const LICENCE_TYPE_ID_SELL_REJECT_EGGS = 126;
export const LICENCE_TYPE_ID_LIMITED_MEDICATED_FEED = 132;
export const LICENCE_TYPE_ID_VETERINARY_LAB = 131;
export const LICENCE_TYPE_ID_SELL_INEDIBLE_EGG_PRODUCT = 133;
